/**
 * Index des composants Privacy/GDPR
 * Boss SEO Plugin
 */

export { default as GDPRConsentBanner } from './GDPRConsentBanner';
export { default as GDPRSettings } from './GDPRSettings';
